import { Button } from "components/Button/Button";
import { FileInput } from "components/FileInput/FileInput";
import { useEffect, useState } from "react";
import { importCustomer } from "./api";
import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { ENDPOINTS, ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { Message } from "components/Message/Message";
import { trans } from "utils/helpers";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { EnumerationTypeSelect } from "components/EnumerationTypeSelect/EnumerationTypeSelect";
import { INVENTORYANDSALES_URL } from "utils/constants";
import { AutoCompleteDictionary } from "components/AutoCompleteDictionary/AutoCompleteDictionary";

interface props {
    showForm?: () => any
    reload?: () => any
   
}
export const ImportCustomersForm = ({showForm,reload }:props) => {

    const [resetForm, setResetForm] = useState(false);
    const [response, setResponse] = useState<any>(null);
    const [selectedFile, setSelectedFile] = useState<any>();
    const [customerData, setCustomerData] = useState<any>();

    const handleSelectedFile = (e: any) => {
        if (e.target.files && e.target.files.length > 0) {
            // setSelectedFile(e.target.files[0]);
            setSelectedFile({url: URL.createObjectURL([...e.target.files][0] )   ,file:[...e.target.files][0]}); 

        }
    };
    async function sendDataToServer(event) {
        
        event.preventDefault();
        try {
            var data = new FormData();
            data.append("file", selectedFile?.file);
            const res = await importCustomer(data,event.target.CustomerOrganizationId.value ,customerData?.createUser?{
                createUser:customerData?.createUser,
                usernameType:event.target?.usernameType?.value,
                useDefaultPassword:customerData?.useDefaultPassword,
            }:{createUser:false} ,event.target.businessActivityTypeId.value )
            reload&&reload()
        } catch (error:any) {
            setResponse(error.response.data)
        }

    }

    useEffect(() => {
        if (resetForm) {
            setResetForm(false);
        }
    }, [resetForm]);

    return (<>
        <div className="col-lg-12 mb-1">
            <div className="card ">
                <div className="card-body">
                    <form
                        className="row d-flex flex-row"
                        onSubmit={sendDataToServer}
                    >
                         {customerData?.createUser &&  
                         <Message message={"Help_ImportCustomer"} type={"instruction"} />

                         }
                        <div className="col-12 col-sm-3">
                        <AutoCompleteDictionary
                            name='businessActivityTypeId'
                            label='businessActivityType'
                            baseUrl={INVENTORYANDSALES_URL}
                            url={ENDPOINTSINVENTORYANDSALES.Sales.BaseDefinitionAndSetting.BusinessActivityType.dictionary}
                            mode={"create"}
                            required={true}
                        />
                        </div>
                        <div className="col-12 col-sm-3">
                        <DictionarySelectBox
                            name='CustomerOrganizationId'
                            label='CustomerOrganization'
                            endPoint={ENDPOINTS.BaseInformation.organization.byType}
                            mode={"create"}
                            required={true}
                        />
                        </div>
                        <div className="col-2 mt-4 ">
                             <CheckableButton
                              labelText={"CreateUser"} 
                              inputName={"createUser"} 
                              onchange={(e)=>{setCustomerData({...customerData ,createUser : e } )}}
                              mode={"create"} 
                              defaultChecked={false}
                              type="checkbox"
                              />
                        </div>  
                        {customerData?.createUser && 
                        <>
                        <div className="col-12 col-sm-3">
                           <EnumerationTypeSelect
                            name="usernameType"
                            enumTypeSelect="usernameType"  
                            mode={"create"} 
                            label="usernameType"
                            />
                        </div>
                        <div className="col-2 mt-4 ">
                             <CheckableButton
                              labelText={"UseDefaultPassword"} 
                              
                              inputName={"useDefaultPassword"} 
                              onchange={(e)=>{setCustomerData({...customerData ,useDefaultPassword : e } )}}
                              mode={"create"} 
                              defaultChecked={false}
                              type="checkbox"
                              />
                        </div>    
                        </> 
                        }
                        <div className="row">
                        <div className="col-lg-4 ">
                            <FileInput
                                maxSize={25600000}
                                lable="CustomersFile"
                                name="CustomersFile"
                                file={selectedFile}
                                onChange={handleSelectedFile}
                                hideSrc={true}
                                accept=".xls, .xlsx"
                                />
                        </div>
                        </div>
                        <div className="col-lg-12 mt-1 btns_form">
                            <Button value="confirm" btnType="submit" />
                            <Button
                                btnType="cancel"
                                value="Cancel"
                                onClick={() => { setResetForm(true);showForm&& showForm() }}
                            />
                        </div>
                    </form >
                    {(response&&response?.Data&&response?.Data?.length > 0)&&
                    <Message withtrans={false} message={response.Data.map(item=>"["+ trans("customercode")+" : "+item.Data +"] , "+ item.Message.replaceAll("\\n", "=>")).join("\n")} type={"error"} />
                    }
                </div>
            </div>
        </div>
    </>)
}